<template>
	<div>
		<van-field :required="formCreateInject.rule.validate[0].required" :label="formCreateInject.prop.title.title"
			input-align="right">
			<template #input>
				<van-switch :size="22" :active-value="activeValue" :inactive-value="inactiveValue" :value="value"
					@change="change" />
			</template>
		</van-field>

	</div>
</template>
<script>
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase],
		props: {
			activeValue: {
				default: () => {
					return 1
				}
			},
			inactiveValue: {
				default: () => {
					return 0
				}
			}
		},
		data() {
			return {

			}
		},
		created() {


		},
		mounted() {


		},
		watch: {

		},
		computed: {

		},
		methods: {
			change(val) {
				this.$emit('input', Object.hasOwn(val, 'value') ? val.value : val)
			},
		}
	}
</script>
<style scope>
	.el-form-item__content {
		line-height: 34px;
	}
</style>
